<section class="sps-pruefung">

  <!-- KOPF -->
  <header class="kopf">
    <button mat-icon-button type="button" (click)="zurueckZumProjekt()" matTooltip="Zurück zum Projekt">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div class="kopf-titel">
      <h1>SPS-Prüfung</h1>
    </div>

    <div class="kopf-aktionen">
      <button mat-stroked-button type="button" (click)="zuDenListen()">
        <mat-icon>developer_board</mat-icon>
        SPS-Listen
      </button>

      
    </div> 
  </header>

  <!-- FORTSCHRITT -->
  <mat-card class="sps-card">
    <mat-card-content>

      <div class="kennzahlen">
        <div class="kennzahl">
          <span>SPS-Signale gesamt</span>
          <strong>{{ fortschritt.gesamt }}</strong>
        </div>

        <div class="kennzahl kennzahl-ok">
          <span>OK</span>
          <strong>{{ fortschritt.ok }}</strong>
        </div>

        <div class="kennzahl kennzahl-nok">
          <span>Nicht OK</span>
          <strong>{{ fortschritt.nichtOk }}</strong>
        </div>

        <div class="kennzahl">
          <span>Ungeprüft</span>
          <strong>{{ fortschritt.ungeprueft }}</strong>
        </div>

        <div class="kennzahl kennzahl-reserve">
          <span>Reserve</span>
          <strong>{{ fortschritt.reserve }}</strong>
        </div>
      </div>

      <div class="fortschritt-info">
        <span>
          Prüffortschritt · {{ fortschritt.bearbeitet }} von {{ fortschritt.gesamt }} bearbeitet
          <ng-container *ngIf="fortschritt.ok + fortschritt.nichtOk > 0"> · Erfolgsquote {{ fortschritt.erfolgProzent }} %</ng-container>
        </span>
        <strong>{{ fortschritt.bearbeitetProzent }} %</strong>
      </div>

      <mat-progress-bar mode="determinate" [value]="fortschritt.bearbeitetProzent" class="fortschritt-balken"></mat-progress-bar>

      <p class="ungeklaert-hinweis" *ngIf="fortschritt.ungeklaert > 0">
        <mat-icon inline>help_outline</mat-icon>
        {{ fortschritt.ungeklaert }} ungeklärte Signalzuordnung{{ fortschritt.ungeklaert === 1 ? '' : 'en' }}.
        <a href="javascript:void(0)" (click)="zurZuordnung()" matTooltip="Gleiche Adresse mit widersprüchlichen Angaben">Zuordnung klären</a>
      </p>

    </mat-card-content>
  </mat-card>

  <!-- PRÜFUNG -->
  <mat-card class="sps-card">
    <mat-card-content>

      <!-- EINGÄNGE / AUSGÄNGE / UNBEKANNT -->
      <div class="richtungs-tabs" role="tablist">
        <button type="button" role="tab" *ngFor="let r of richtungen" [class.aktiv]="filter.richtung === r.wert"
          [attr.aria-selected]="filter.richtung === r.wert" (click)="richtungSetzen(r.wert)">
          <mat-icon>{{ r.icon }}</mat-icon>
          {{ r.text }}
          <span class="tab-anzahl">{{ r.anzahl }}</span>
        </button>
      </div>

      <!-- FILTER -->
      <div class="filter-zeile">

        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-suche">
          <mat-label>Suchen</mat-label>
          <input matInput [(ngModel)]="filter.suche" (ngModelChange)="textGeaendert()" (keyup.enter)="sucheAnwenden()"
            placeholder="Signalname, Adresse, BMK, Beschreibung, Station">
          <button mat-icon-button matSuffix type="button" *ngIf="filter.suche" (click)="sucheLeeren()" matTooltip="Suche leeren">
            <mat-icon>close</mat-icon>
          </button>
          <mat-icon matSuffix *ngIf="!filter.suche">search</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-status">
          <mat-label>Prüfstatus</mat-label>
          <mat-select [value]="filter.status" (selectionChange)="statusSetzen($event.value)">
            <mat-option [value]="null">Alle</mat-option>
            <mat-option *ngFor="let o of statusOptionen" [value]="o.wert">
              <span class="status-punkt" [ngClass]="o.klasse"></span>{{ o.text }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Anlagenteil – prüfungsbezogen: nur Anlagenteile, die bei den Signalen dieses Projekts vorkommen -->
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-anlagenteil" *ngIf="zeigeAnlagenteilFilter">
          <mat-label>Anlagenteil</mat-label>
          <mat-select [value]="anlagenteilAuswahl" (selectionChange)="anlagenteilSetzen($event.value)">
            <mat-option [value]="null">Alle Anlagenteile</mat-option>
            <mat-option *ngIf="zeigeOhneAnlagenteil" value="ohne">Ohne Anlagenteil ({{ anlagenteilOptionen.ohneAnlagenteil }})</mat-option>
            <mat-option *ngIf="anlagenteilAuswahlFehlt" [value]="filter.anlagenteilId">Anlagenteil #{{ filter.anlagenteilId }} (nicht in dieser Prüfung)</mat-option>
            <mat-option *ngFor="let a of anlagenteilOptionen.anlagenteile" [value]="a.anlagenteilId">{{ a.name }} ({{ a.anzahl }})</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-sortierung">
          <mat-label>Sortierung</mat-label>
          <mat-select [value]="filter.sortierung" (selectionChange)="sortierungSetzen($event.value)">
            <mat-option *ngFor="let s of sortierungen" [value]="s.wert">{{ s.text }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-slide-toggle [checked]="!!filter.nurOffen" (change)="nurOffeneSetzen($event.checked)" class="filter-offen"
          matTooltip="Nur ungeprüfte und nicht in Ordnung befundene Signale">
          Nur offene
        </mat-slide-toggle>

        <mat-slide-toggle [checked]="!!filter.nurGeaendertSeitPruefung" (change)="nurGeaendertSetzen($event.checked)" class="filter-offen"
          matTooltip="Nur geprüfte Signale, deren Listeneinträge sich seit der Prüfung durch ein Listenupdate geändert haben">
          Seit Prüfung geändert
        </mat-slide-toggle>

        <button mat-button type="button" (click)="erweitertUmschalten()" [class.aktiv]="erweitert">
          <mat-icon>{{ erweitert ? 'expand_less' : 'tune' }}</mat-icon>
          {{ erweitert ? 'Weniger Filter' : 'Weitere Filter' }}
        </button>

        <button mat-stroked-button type="button" (click)="filterZuruecksetzen()" [disabled]="!filterAktiv">
          <mat-icon>filter_alt_off</mat-icon>
          Zurücksetzen
        </button>

      </div>

      <!-- ERWEITERTE FELDSUCHE -->
      <div class="filter-zeile filter-erweitert" *ngIf="erweitert">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Signalname</mat-label>
          <input matInput [(ngModel)]="filter.name" (ngModelChange)="textGeaendert()" (keyup.enter)="sucheAnwenden()">
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>SPS-Adresse</mat-label>
          <input matInput [(ngModel)]="filter.adresse" (ngModelChange)="textGeaendert()" (keyup.enter)="sucheAnwenden()" placeholder="z. B. I0.0">
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>BMK</mat-label>
          <input matInput [(ngModel)]="filter.bmk" (ngModelChange)="textGeaendert()" (keyup.enter)="sucheAnwenden()">
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Beschreibung</mat-label>
          <input matInput [(ngModel)]="filter.beschreibung" (ngModelChange)="textGeaendert()" (keyup.enter)="sucheAnwenden()">
        </mat-form-field>
      </div>

      <!-- LADEZUSTAND / FEHLER -->
      <mat-progress-bar *ngIf="laedt" mode="indeterminate"></mat-progress-bar>

      <div class="fehlermeldung" *ngIf="fehler">
        <mat-icon>error_outline</mat-icon>
        <span>{{ fehler }}</span>
        <button mat-button type="button" (click)="ladeSignale()">Erneut laden</button>
      </div>

      <!-- SIGNALTABELLE -->
      <ng-container *ngIf="seite as daten">

        <div class="tabellen-info">
          <span>
            {{ daten.gesamt }} Signal{{ daten.gesamt === 1 ? '' : 'e' }}
            <ng-container *ngIf="filterAktiv"> (gefiltert)</ng-container>
          </span>
          
        </div>

        <div class="tabellen-scroll" [class.laedt]="laedt">
          <table class="signal-tabelle">
            <thead>
              <tr>
                <th class="sp-signal">Signal</th>
                <th class="sp-adresse">SPS-Adresse</th>
                <th class="sp-bmk">BMK / Station</th>
                <th class="sp-beschreibung">Beschreibung</th>
                <th class="sp-status">Prüfstatus</th>
                <th class="sp-aktion"></th>
              </tr>
            </thead>

            <tbody>
              <ng-container *ngFor="let signal of daten.eintraege; trackBy: trackBySignal">
                <tr class="signal-zeile" [ngClass]="'zeile-' + option(signal.pruefstatus).klasse"
                  [class.speichert]="wirdGespeichert(signal)" [class.gespeichert]="wurdeGespeichert(signal)"
                  (click)="oeffneSignal(signal)" tabindex="0" (keydown.enter)="oeffneSignal(signal)">

                  <td class="sp-signal">
                    <div class="signal-name">
                      <span class="name" [matTooltip]="signal.name || ''" matTooltipShowDelay="500">{{ signal.name || '–' }}</span>

                      <span class="quellen-badge" *ngIf="signal.quellenAnzahl > 1" [matTooltip]="quellenText(signal)"
                        [class.quellen-abweichend]="signal.hatAbweichendeQuellen">
                        <mat-icon inline>{{ signal.hatAbweichendeQuellen ? 'difference' : 'layers' }}</mat-icon>
                        {{ signal.quellenAnzahl }}
                      </span>

                      <mat-icon class="ungeklaert-icon" *ngIf="signal.hatUngeklaerteZuordnung" inline
                        matTooltip="Zuordnung einer Quelle noch ungeklärt">help_outline</mat-icon>

                      <span class="geaendert-badge" *ngIf="signal.geaendertSeitPruefungAmUtc"
                        [matTooltip]="'Seit der Prüfung durch ein Listenupdate geändert – der Prüfstatus wurde nicht zurückgesetzt. ' + (signal.geaendertSeitPruefungHinweis || '')">
                        <mat-icon inline>update</mat-icon>
                        Seit Prüfung geändert
                      </span>
                    </div>

                    <span class="signal-sub" *ngIf="signal.zuletztGeprueftAmUtc">
                      geprüft {{ signal.zuletztGeprueftAmUtc | date:'dd.MM.yy HH:mm' }}<ng-container *ngIf="signal.zuletztGeprueftVon"> · {{ signal.zuletztGeprueftVon }}</ng-container>
                    </span>

                    <!-- Anlagenteil: der eindeutige der bestätigten Quellen; bei Widerspruch alle Namen, kein leerer Chip -->
                    <span class="anlagenteil-chip" *ngIf="signal.anlagenteilName || signal.anlagenteilNamen?.length"
                      [matTooltip]="anlagenteilTooltip(signal)">
                      <mat-icon inline>account_tree</mat-icon>
                      <span>{{ signal.anlagenteilName || signal.anlagenteilNamen?.join(' / ') }}</span>
                    </span>
                  </td>

                  <td class="sp-adresse">
                    <span class="adresse">{{ signal.adresseNormiert || '–' }}</span>
                    <span class="signal-sub" *ngIf="signal.adresseOriginal && signal.adresseOriginal !== signal.adresseNormiert">{{ signal.adresseOriginal }}</span>
                  </td>

                  <td class="sp-bmk">
                    <span>{{ signal.bmk || '–' }}</span>
                    <span class="signal-sub" *ngIf="signal.stationsSchluessel">{{ signal.stationsSchluessel }}</span>
                  </td>

                  <td class="sp-beschreibung">
                    <span class="beschreibung" [matTooltip]="signal.beschreibung || ''" matTooltipShowDelay="500"
                      [matTooltipDisabled]="(signal.beschreibung || '').length < 40">{{ signal.beschreibung || '–' }}</span>
                    <span class="signal-sub bemerkung" *ngIf="signal.bemerkung" [matTooltip]="signal.bemerkung" matTooltipShowDelay="300">
                      <mat-icon inline>chat_bubble_outline</mat-icon>{{ signal.bemerkung }}
                    </span>
                  </td>

                  <!-- Status: Klick darf die Zeile NICHT öffnen -->
                  <td class="sp-status" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()">
                    <div class="status-feld" *ngIf="canEdit; else nurLesen">
                      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="status-select"
                        [ngClass]="option(signal.pruefstatus).klasse">
                        <mat-select #sel [value]="signal.pruefstatus" [disabled]="wirdGespeichert(signal)"
                          (selectionChange)="statusAendern(signal, $event.value, sel)" panelClass="sps-status-panel"
                          [attr.aria-label]="'Prüfstatus von ' + (signal.name || signal.adresseNormiert)">
                          <mat-select-trigger>
                            <span class="status-wert" [ngClass]="option(signal.pruefstatus).klasse">
                              <mat-icon inline>{{ option(signal.pruefstatus).icon }}</mat-icon>
                              {{ option(signal.pruefstatus).text }}
                            </span>
                          </mat-select-trigger>
                          <mat-option *ngFor="let o of statusOptionen" [value]="o.wert">
                            <span class="status-wert" [ngClass]="o.klasse">
                              <mat-icon inline>{{ o.icon }}</mat-icon>
                              {{ o.text }}
                            </span>
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <mat-spinner diameter="18" class="status-spinner" *ngIf="wirdGespeichert(signal)"></mat-spinner>
                      <mat-icon class="status-ok-icon" *ngIf="wurdeGespeichert(signal) && !wirdGespeichert(signal)" matTooltip="Gespeichert">done</mat-icon>
                    </div>

                    <ng-template #nurLesen>
                      <span class="status-badge" [ngClass]="option(signal.pruefstatus).klasse">
                        <mat-icon inline>{{ option(signal.pruefstatus).icon }}</mat-icon>
                        {{ option(signal.pruefstatus).text }}
                      </span>
                    </ng-template>
                  </td>

                  <td class="sp-aktion" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()">
                    <button mat-icon-button type="button" (click)="oeffneSignal(signal)" matTooltip="Signaldetails öffnen">
                      <mat-icon>open_in_new</mat-icon>
                    </button>
                    <button mat-icon-button color="warn" type="button" *ngIf="canEdit" [disabled]="wirdGeloescht(signal) || wirdGespeichert(signal)"
                      (click)="signalLoeschen(signal, $event)" matTooltip="Signal löschen – nur aus der Prüfung entfernen oder vollständig löschen">
                      <mat-icon>delete_outline</mat-icon>
                    </button>
                  </td>
                </tr>

                <!-- Fehler je Zeile (z. B. Versionskonflikt) -->
                <tr class="zeilen-fehler" *ngIf="zeilenFehler.get(signal.id) as text">
                  <td colspan="6">
                    <mat-icon inline>error_outline</mat-icon>
                    <span>{{ text }}</span>
                    <button mat-button type="button" (click)="zeilenFehlerSchliessen(signal)">Schließen</button>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>

          <p class="leer" *ngIf="!laedt && daten.eintraege.length === 0">
            <ng-container *ngIf="fortschritt.gesamt === 0">
              Noch keine SPS-Signale vorhanden – zuerst eine SPS-Zuordnungs- oder PLC-Tag-Liste importieren.
            </ng-container>
            <ng-container *ngIf="fortschritt.gesamt > 0">
              Keine Signale für diese Auswahl.
              <a href="javascript:void(0)" *ngIf="filterAktiv" (click)="filterZuruecksetzen()">Filter zurücksetzen</a>
            </ng-container>
          </p>
        </div>

        <!-- PAGINATION (serverseitig) -->
        <mat-paginator [length]="daten.gesamt" [pageIndex]="(filter.seite ?? 1) - 1" [pageSize]="filter.groesse ?? 50"
          [pageSizeOptions]="seitenGroessen" [showFirstLastButtons]="true" [disabled]="laedt" (page)="seiteGewechselt($event)">
        </mat-paginator>

      </ng-container>

    </mat-card-content>
  </mat-card>

</section>
